export default __webpack_public_path__ + "static/media/end-call.ce281132.svg";